let i18n;

export function initI18n (initI18n) {
  i18n = initI18n;
}

export function useI18n () {
  return i18n;
}
